import { selector } from 'recoil';

import { surveyAtom } from '@src/recoil/atoms/survey';
import { validateQuestionType } from '@src/services/surveys/utils/validation';
import { selectSurveyQuestions } from './surveyQuestions';

/**
 * @name selectSurveyState
 * @external https://recoiljs.org/docs/basic-tutorial/selectors
 * @description tbd...
 */
export const selectSurveyState = selector({
  get: ({ get }) => {
    const { answers } = get(surveyAtom);
    const { active } = get(selectSurveyQuestions);

    // Store the position each question is at in the list
    const questionsWithErrors: number[] = [];

    // Now we process the remaining questions and update our validation status
    active.forEach((questions, index) => {
      const { __typename, ...question } = questions;
      const errorMsg = validateQuestionType(question, answers);

      // If any part of the data is invalid, the whole thing is
      if (errorMsg) {
        questionsWithErrors.push(index + 1);
      }
    });

    return {
      errors: questionsWithErrors,
      valid: questionsWithErrors.length === 0
    };
  },

  key: 'selectSurveyState'
});
